module.exports = __webpack_public_path__ + "img/tmb.2c7ee2af.png";